//---------------------------------------------
// Grupos Module 
//---------------------------------------------
// Módulo para gerenciar as ações do grupo

import axios from '../../services/api';
import Cookies from 'js-cookie';
var JWT = () => {
    return (Cookies.get("accessToken") ? Cookies.get("accessToken") : "JWT VAZIO")
}

// STATES
const state = () => ({
    groups: [],
    membrosGroup: []
})

// MUTATIONS
const mutations = {
    setListGroups(state, payload){
        state.groups = payload
    },

    setListMembrosGrupo(state, payload){
        state.membrosGroup = payload
    }
}

// ACTIONS
const actions = {
    //-- ACTION REQUISICAO DE CRIAR GRUPO
    async setCreateGroup( _, payload)  {
        var formData = new FormData();
        formData.append("nome", payload.nome);
        formData.append("descricao", payload.descricao);
        formData.append("atuacao", payload.atuacao);
        formData.append("rua", payload.rua);
        formData.append("numero", payload.numero);
        formData.append("bairro", payload.bairro);
        formData.append("complemento", payload.complemento);
        formData.append("cep", payload.cep);
        formData.append("idCidade", payload.id_cidade);
        if (payload.imagem) {
            formData.append("imagem", payload.imagem)
        }
        await axios
            .post(`grupo/`, 
            formData,
            {   
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {})
            .catch((error) => console.log(error.message))
    },

    //-- ACTION REQUISICAO DOS GRUPOS
    async setListGroups({ commit }) {
        await axios
            .get(`grupo/listUserGrupos`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setListGroups', response.data)
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION REQUISICAO DO LISTMEMBROS
    async setListMembrosGrupo({ commit }, idGrupo) {
        await axios
            .get(`membros_grupo/${idGrupo}`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setListMembrosGrupo', response.data)
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION REQUISICAO DE CRIAR MEMBRO DO GRUPO - TEMOS QUE ARRUMAR!!!!!!!!!!!!!!!
    // *********CONTINUA DANDO ERRO 400 NO CONSOLE - BAD REQUEST!!!!!!!!!!!!!!
    async setCreateGroupMember( _, payload)  {
        await axios
            .post(`membros_grupo/${payload.id_grupo}`, {
                id_permissao: payload.id_permissao,
                id_usuario: payload.id_usuario
            },
                {headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {})
            .catch((error) => console.log(error.message))
    },

     //-- ACTION DELETE GRUPO
     async deleteGrupo(_, payload) {
        await axios
            .delete(`grupo/${payload.idGrupo}`, {
                
            },{
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION DELETE MEMBRO DO GRUPO
    async deleteMembroGrupo(_, payload) {
        await axios
            .delete(`grupo/${payload.idGrupo}`, {
                idUsuario: payload.idUsuario
            },{
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
            })
            .catch((error) => console.log(error.message))
    },
}

// GETTERS
const getters = {
    getListGroups(state){
        try {
            return state.groups.data
        } catch(e) {
            return []
        }
    },

    getListMembrosGrupo(state){
        try {
            return state.membrosGroup.data
        } catch(e) {
            return []
        }
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}
